import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ProcessModule } from '@spartacus/core';
import { CALLBACK_FEATURE } from './callback-state';
import { reducerProvider, reducerToken } from './reducers';

@NgModule({
  imports: [ProcessModule.forRoot(), StoreModule.forFeature(CALLBACK_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class CallBackStoreModule {}
